/* template */
<template minapp="mpx" xlang="wxml"><div class="card-main"><div class="refund"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/tpmylUP53m1652434050989.png" class="img"></mpx-image><div class="refund-info" v-if="(refundInfo)"><span class="refund-content title">{{refundInfo.passenger_name}}</span><div class="refund-content title">{{refundInfo.from_station_name }}<es-icon name="arrow-switch-right" color="#666666" size="20" class="arrow-right-icon"/>{{ refundInfo.to_station_name}}  {{refundInfo.train_code}}</div><span class="refund-content sub-title">{{startTime}}</span><span class="refund-content-reason" v-if="(showReason)">退票原因:{{refundInfo.reason}}</span></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3a1bd67e"}'>
  @import '~@/mixins/stylus/color.styl'

  .card-main
    border-radius 8px
    padding 16px 15px
    display flex
    flex-direction row
    color $train-color-333
    justify-content space-between
  .refund
    display flex
    flex-direction row
  .refund-info
    display flex
    flex-direction column
    margin-left 8px
    width calc(100vw - 90px)
  .refund-content
    font-family PingFangSC
    margin-bottom 2px
    display flex
    flex-direction row
    &.title
      font-size 15px
      font-weight 500
    &.sub-title
      font-size 12px
      font-weight 300
      color $train-color-666
    &-reason
      font-size 12px
      font-weight 300
      color $train-color-999
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      margin-right 20px
  .refund-detail
    display flex
    flex-direction row
    font-size 13px
    line-height 15px
    color $train-color-theme-blue
  .img
    flex 0 0 18px
    margin-top 1px
    width 18px
    height 18px
  .arrow-right-icon
    margin 0px 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3a1bd67e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./refund-info-card.mpx.js?isComponent&outputPath=components%2Frefund-info-card3a1bd67e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./refund-info-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Frefund-info-card3a1bd67e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3a1bd67e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/refund-info-card3a1bd67e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
